import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { toIntlDateTimeFormat } from '@zedoc/date';
import { useTranslation } from 'react-i18next';
import { Markdown } from '@zedoc/react-markdown';
import { getIcon } from './helpers';
import { toIntlRelativeTimeFormat } from '../../utils/date';

const NoticeBoardCard = ({
  type,
  className,
  subject,
  content,
  author,
  dateStart,
  timeStart,
  createdAt,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const typeClassName = useMemo(() => {
    switch (type) {
      case 'info':
        return 'border-info';
      case 'warning':
        return 'border-warning';
      case 'success':
        return 'border-success';
      default:
        return 'border-divider';
    }
  }, [type]);

  const icon = useMemo(() => getIcon(type), [type]);

  return (
    <div
      className={`p-4 bg-surface rounded-md border-l-4 stack-4 ${className} ${typeClassName}`}
    >
      <div className="cluster-2 items-center">
        {icon}
        <span className="font-medium truncate">
          {subject[language] || Object.values(subject)[0]}
        </span>
      </div>
      <hr />
      <Markdown source={content[language] || Object.values(content)[0]} />
      <small>
        {`${t('postedBy')} `} {author} {`${t('on')} `}
        {toIntlDateTimeFormat(language, new Date(createdAt), {
          dateStyle: 'medium',
          timeStyle: 'medium',
        })}
        {' • '}
        {toIntlRelativeTimeFormat(language, new Date(createdAt))}
      </small>
    </div>
  );
};

NoticeBoardCard.propTypes = {
  type: PropTypes.oneOf(['info', 'warning', 'success', 'neutral']),
  subject: PropTypes.objectOf(PropTypes.string).isRequired,
  content: PropTypes.objectOf(PropTypes.string).isRequired,
  author: PropTypes.string.isRequired,
  dateStart: PropTypes.string.isRequired,
  timeStart: PropTypes.string.isRequired,
  className: PropTypes.string,
  createdAt: PropTypes.string.isRequired,
};

NoticeBoardCard.defaultProps = {
  type: 'neutral',
  className: '',
};

export default NoticeBoardCard;
